import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "flex items-center gap-3" }
const _hoisted_3 = { class: "flex h-11 w-11 items-center justify-center rounded-xl bg-cyan-50 text-cyan-800" }
const _hoisted_4 = { class: "flex justify-end gap-x-4 w-full" }
const _hoisted_5 = { class: "overflow-hidden rounded-2xl border border-slate-200" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_IpgTransactionSkelton = _resolveComponent("IpgTransactionSkelton")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_ExternalTransactionsTable = _resolveComponent("ExternalTransactionsTable")!
  const _component_CustomPaginationComponent = _resolveComponent("CustomPaginationComponent")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "user-transactions-page pa-2 my-3 sm:pa-4 sm:my-6"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        flat: "",
        class: "user-transactions-card pa-3 sm:pa-6"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, [
                _createVNode(_component_v_icon, { size: "22" }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode("mdi-account-switch-outline", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "title" }, [
                _createElementVNode("p", { class: "text-xl font-bold text-slate-900" }, "تراکنش‌های کاربر"),
                _createElementVNode("span", { class: "mt-1 block text-sm font-normal text-slate-500" }, "سوابق تراکنش و پرداخت کاربر")
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_ButtonComponent, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.back())),
                class: "min-w-[150px] max-w-[150px]",
                text: 'بازگشت',
                status: 'primary'
              })
            ])
          ]),
          (_ctx.getLoadingPanel)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 0,
                class: "mt-6"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (index) => {
                    return _createVNode(_component_v_col, {
                      cols: "12",
                      key: index
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_IpgTransactionSkelton)
                      ]),
                      _: 1
                    })
                  }), 64))
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "overflow-x-auto"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_ExternalTransactionsTable, { transactions: _ctx.getExternalTransactions }, null, 8, ["transactions"])
                      ]),
                      (Number(_ctx.getGlobalPagination.total) > Number(_ctx.getGlobalPagination.limit))
                        ? (_openBlock(), _createBlock(_component_v_row, {
                            key: 0,
                            justify: "center",
                            class: "mt-4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "12",
                                sm: "8",
                                md: "6"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_CustomPaginationComponent, {
                                    "total-items": _ctx.getGlobalPagination.total,
                                    "items-per-page": 50,
                                    onPageChange: _ctx.handelPagination
                                  }, null, 8, ["total-items", "onPageChange"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}